import React, { useCallback, useState } from 'react'

import MobileSelectTripDestinations from './EditTripDetails/MobileSelectTripDestinations'

import { EmptyArray } from 'lib/arrayUtils'
import { UpdateTripError } from 'tripPlanner/api/types'
import { useUpdateTrip } from 'tripPlanner/hooks/api'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

interface PlaceSelection {
  id: string
  name: string
}

interface Props {
  tripId: string
  initialDestinations?: Array<PlaceSelection>
}

const MobileUpdateTripDestinations = ({
  tripId,
  initialDestinations = EmptyArray,
}: Props) => {
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined)

  const { closeModal } = useModalCallbacks()

  const { mutate, isLoading: isSaving } = useUpdateTrip({
    onSuccess: () => {
      closeModal()
    },
    onError: (e: UpdateTripError) => {
      if (e.status === 422) {
        setErrorMsg(e.message)
      }
    },
  })

  const onSave = useCallback(
    (places: Array<PlaceSelection>) => {
      // update trip with new destinations
      const destinationPlaceIds = places.map((p) => p.id)
      mutate({
        tripId,
        destinationPlaceIds,
      })
    },
    [mutate, tripId],
  )

  return (
    <MobileSelectTripDestinations
      title={
        initialDestinations.length > 0
          ? 'Update destinations'
          : 'Add destinations'
      }
      initialDestinations={initialDestinations}
      onChange={onSave}
      isSubmitting={isSaving}
      errorMsg={errorMsg}
      doneLabel={initialDestinations.length > 0 ? 'Save' : 'Add destinations'}
    />
  )
}

export default MobileUpdateTripDestinations
